// removed by extract-text-webpack-plugin
module.exports = {"CustomMarker":"CustomIcon__CustomMarker__3YRlu"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/CustomIcon/CustomIcon.css
// module id = 255
// module chunks = 0